// @ts-nocheck
/* eslint-disable */
export const scoutingIcon = {
  data: `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="2.5" y="5.25" width="19" height="13.5" rx="2" stroke="currentColor" stroke-width="1.4521"/><path d="M12 5.25V18.75" stroke="currentColor" stroke-width="1.4521"/><circle cx="12" cy="12" r="2.3" stroke="currentColor" stroke-width="1.4521"/><path d="M2.5 8.9H5.4V15.1H2.5" stroke="currentColor" stroke-width="1.4521" stroke-linejoin="round"/><path d="M21.5 8.9H18.6V15.1H21.5" stroke="currentColor" stroke-width="1.4521" stroke-linejoin="round"/></svg>`,
  name: 'scouting' as const,
};
